export default "/directory/static/logo.cd613997.svg";